export default __webpack_public_path__ + "static/media/logoSidenav.680d7a19.png";